import React, { useState, useEffect, useRef } from 'react'
import CreatableSelect from "react-select/creatable";
import { getPersons } from "api/AccountsApi"
import { getAllUsers } from "api/UsersApi"
import { getTasksById } from "api/SalesApi"
import { useSelector } from 'react-redux';
import "./style.css"
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import moment from 'moment';
import $ from 'jquery'
import { getDealsApi } from "api/SalesApi"

export default function CreateTaskModal({ personData, handleCreateTask, handleUpdateTask, userFlow, editTask, taskId ,setEditTask }) {

  const [reminderCustomDate, setReminderCustomDate] = useState(false)
  const [taskTitle, setTaskTitle] = useState('')
  const [taskAssignee, setTaskAssignee] = useState('')
  const [taskType, setTaskType] = useState('')
  const [taskDueDate, setTaskDueDate] = useState('')
  const [taskReminder, setTaskReminder] = useState('No reminder')
  const [taskReminderCustomDate, setTaskReminderCustomDate] = useState(null)
  const [taskNote, setTaskNote] = useState('')
  const [assignee, setAssignee] = useState([]);
  const [contact, setContact] = useState(null);
  const [contactValues, setContactValues] = useState({ label: '', value: '' });
  const [contactList, setContactList] = useState([]);
  const [dealValue, setDealValue] = useState({ label: '', value: '' });


  const [hasDeals, setHasDeals] = useState(false);

  const [deals, setDeals] = useState([]);

  const [dealId, setDealId] = useState(null);


  const taskTitleRef = useRef("");
  const taskAssigneeRef = useRef("");
  const taskTypeRef = useRef("");
  const taskDueDateRef = useRef("");
  const taskContactRef = useRef("");
  const taskReminderRef = useRef("");
  const taskReminderCustomDateRef = useRef("");
  const taskNoteRef = useRef("");
  $('#createTask').on('hidden.bs.modal', function () {
    // do something…
    try {
      reset();
      setEditTask(false); 
    } catch (e) { }
  });
  useEffect(() => {
    getAllUsers(100, 0).then(users => {
      setAssignee(users)
    })
    getPersons(50, 0, "").then(users => {
      users = users.map(u => { return { label: (u.firstName + " " + u.lastName+` ${u.email}`), value: u.id } })
      setContactList(users)
    })
    getDealsApi(50, 0,
      ""
    ).then(data => {
      data = data.map(u => { return { label: u.name.value, value: u.id } })
      setDeals(data);

    })
    if (editTask) {
      getTasksById(taskId).then(data => {
        let date = moment.utc(new Date(data.dueDateTime)).format('YYYY-MM-DDTHH:mm')
        let customReminderDate = moment.utc(new Date(data.reminderDateTime)).format('YYYY-MM-DDTHH:mm')

        taskTitleRef.current.value = data.title
        taskAssigneeRef.current.value = data.assignee.id
        taskTypeRef.current.value = data.type
        taskDueDateRef.current.value = date
        taskReminderRef.current.value = data.reminderType
        taskNoteRef.current.value = data.text
        setTaskTitle(data.title)
        setTaskAssignee(data.assignee.id)
        setTaskType(data.type)
        setTaskDueDate(date)
        setTaskReminder(data.reminderType)
        setTaskReminderCustomDate(data.reminderCustomDate)
        setTaskNote(data.text)
        if (data.person) {
          setContact({ label: data.person.firstName + ' ' + data.person.lastName, value: data.person.id })
          let persondata = { value: data.person.id, label: (data.person.firstName + ' ' + data.person.lastName) }

          setContactValues(persondata)
          setHasDeals(false)

        }

        if (data && data.deal) {
          setDealId({ value: data.deal.id, label: data.deal.name })
          setHasDeals(true)
        }

        if (data.reminderType == 'Custom Date') {
          setReminderCustomDate(true)
          taskReminderCustomDateRef.current.value = customReminderDate
        }
      })
    } else {
      setReminderCustomDate(false)
      taskTitleRef.current.value = ''
      taskAssigneeRef.current.value = ''
      taskTypeRef.current.value = ''
      taskDueDateRef.current.value = ''
      taskReminderRef.current.value = 'No reminder'
      if (taskReminderRef.current.value == 'Custom Date') {
        taskReminderCustomDateRef.current.value = ''
      }
      taskNoteRef.current.value = ''

    }
  }, [editTask, taskId])

  const reset = () => {
    if (!editTask) {
      setReminderCustomDate(false)
      taskTitleRef.current.value = ''
      taskAssigneeRef.current.value = ''
      taskTypeRef.current.value = ''
      taskDueDateRef.current.value = ''
      taskReminderRef.current.value = 'No reminder'
      if (taskReminderRef.current.value == 'Custom Date') {
        taskReminderCustomDateRef.current.value = ''
      }
      taskNoteRef.current.value = ''
      setContact(null)
      setContactValues({ label: '', value: '' })
      setDealValue({ label: '', value: '' })
      setDealId(null)
      setHasDeals(false)

    }
  }



  const createTask = () => {
    let data = {
      title: taskTitle,
      text: taskNote,
      type: taskType,
      assignee: taskAssignee,
      reminderType: taskReminder,
      reminderDateTime: taskReminderCustomDate,
      person: userFlow === 'fromPerson' ? personData?.id : !hasDeals && contact ? contact.value : null,
      dueDateTime: taskDueDate,
      deal: userFlow != 'fromPerson' && hasDeals && dealId ? dealId.value : null
    }
    handleCreateTask(data)
  }
  const updateTask = () => {
    let data = {
      title: taskTitle,
      text: taskNote,
      type: taskType,
      assignee: taskAssignee,
      reminderType: taskReminder,
      reminderDateTime: taskReminderCustomDate,
      person: userFlow === 'fromPerson' ? personData?.id : !hasDeals && contact ? contact.value : null,
      dueDateTime: taskDueDate,
      deal: userFlow != 'fromPerson' && hasDeals && dealId ? dealId.value : null
    }
    handleUpdateTask(taskId, data)
  }

  const handleInputChange = (inputValue, actionMeta) => {

    if (inputValue) {
      getPersons(100, 0, inputValue).then(users => {
        users = users.map(u => { return { label: (u.firstName + " " + u.lastName + ` ${u.email}`), value: u.id } })
        setContactList(users)
      })
    }
  };

  const inputChangeDeals = (inputValue, actionMeta) => {
    getDealsApi(100, 0,
      inputValue
    ).then(data => {
      data = data.map(u => { return { label: u.name.value, value: u.id } })
      setDeals(data);

    })
  }

  const customStyles = {
    valueContainer: (provided, state) => ({
      ...provided,
      //  padding: '2px 8px',
      //  backgroundColor: "red",
      outline: 'none',
      outline: 'none',
      paddingTop: 0,
      marginTop: 0,
      paddingBottom: '17px',
    }),
    placeholder: (provided, state) => ({
      ...provided,
      //    padding: '2px 8px',
      //  backgroundColor: "red",
      outline: 'none',
    }),
    control: base => ({
      ...base,
      border: "1px solid rgb(118, 118, 118)",
      boxShadow: 'none',
      paddingTop: '2px'

    })

  }

  return (
    <div class="modal fade create-task-modal"
      id='createTask'>
      <div class="modal-dialog kw_md">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">Create Task</div>
            <span class="icon-Group-240" data-dismiss="modal">  </span>
          </div>
          <form onSubmit={(e) => {
            e.preventDefault();
            if (editTask)
              updateTask()
            else
              createTask()
            reset()

            $('#createTask').modal('hide');



          }}>
            <div class="modal-body">
              <div className='row'>
                <div className='col-12 task-modal-input'>
                  <label for="task_title" >
                    Task Title
                  </label>
                  <input
                    required
                    type="text"
                    id="task_title"
                    className=' kwDesign w-100'
                    onChange={(e) => setTaskTitle(e.target.value)}
                    ref={taskTitleRef}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-6 task-modal-input'>
                  <label for="task_title" >
                    Assignee
                  </label>
                  <select
                    required
                    type="text"
                    id="task_title"
                    className='kwDesign2 w-100'
                    onChange={(e) => setTaskAssignee(e.target.value)}
                    ref={taskAssigneeRef}
                  >
                    <option value="">Select Assignee</option>
                    {assignee && assignee.map(user => {
                      return <option value={user.id}>{user.name}</option>
                    })}
                  </select>
                </div>

                <div className='col-6 task-modal-input'>
                  <label for="task_title"  >
                    Type
                  </label>
                  <select
                    required
                    type="text"
                    id="task_title"
                    className=' kwDesign2 w-100'
                    onChange={(e) => setTaskType(e.target.value)}
                    ref={taskTypeRef}
                  >
                    <option value="">Select Type</option>
                    <option value="email">Email</option>
                    <option value="call">Call</option>
                    <option value="todo">Todo</option>
                  </select>
                </div>
              </div>
              <div className='row'>
                <div className='col-6 task-modal-input'>

                  <label for="task_duedate"  >
                    Due Date
                  </label>
                  <input
                    required
                    id="task_duedate"
                    type="datetime-local"
                    className="kwDesign w-100"
                    onChange={(e) => {
                      let date = moment(new Date(e.target.value)).format('YYYY-MM-DD hh:mm a')
                      setTaskDueDate(date)
                      //setTimeout(() => { taskReminderCustomDateRef.current.max =},1000)

                    }}
                    ref={taskDueDateRef}
                  />

                </div>

                <div className='col-6 task-modal-input'>
                  <div style={{ display: 'flex' }}
                  >
                    <div className='toggler' style={(!(editTask && (contact || dealId)) && userFlow != 'fromPerson') ? {
                      display: 'flex'
                    } : {
                      display: 'flex', opacity: 0.5
                    }}
                    >
                      <h6 onClick={(e) => {
                        if (userFlow == 'fromPerson' || (editTask && dealId)) return

                        setHasDeals(false)
                      }} className={!hasDeals ? 'selected' : 'notSelected'}>Contacts</h6>

                      <h6 onClick={(e) => {
                        if (userFlow == 'fromPerson' || (editTask && contact)) return

                        setHasDeals(true)
                      }} className={hasDeals ? 'selected' : 'notSelected'} >Deal</h6>
                    </div>
                  </div>

                  {!hasDeals ?

                    <>
                      {
                        userFlow === 'fromPerson' ? <select
                          type="text"
                          id="task_title"
                          className='kwDesign2 w-100'
                          value={personData?.firstName}
                          disabled
                        >
                          <option value="" selected>{personData?.firstName}</option>
                        </select>
                          : <CreatableSelect
                            isClearable
                            formatCreateLabel={() => undefined}
                            onInputChange={handleInputChange}
                            onChange={newValue => newValue && setContact({ label: newValue.label, value: newValue.value })}
                            options={contactList}
                            //defaultValue={contactValues}
                            value={contact}
                            styles={customStyles}

                          />
                      }
                    </>

                    :
                    <CreatableSelect
                      formatCreateLabel={() => undefined}

                      isClearable
                      onInputChange={inputChangeDeals}
                      // value={task}
                      onChange={newValue => setDealId({ label: newValue.label, value: newValue.value })}

                      styles={customStyles}

                      options={deals}

                      value={dealId}



                    // isClearable
                    // onInputChange={handleInputChange}
                    // onChange={newValue => setContact(newValue.value)}
                    // options={contactList}
                    />



                  }

                  {/* 
                <label for="task_title"  >
                  Contact
                </label>
                {
                  ()=>{
                  if (userFlow === 'fromPerson' ) return <select
                    type="text"
                    id="task_title"
                    className='kwDesign2 w-100'
                    value={personData?.firstName}
                    disabled
                  >
                    <option value="" selected>{personData?.firstName}</option>
                  </select> 
                 else return <CreatableSelect
                    isClearable
                    onInputChange={handleInputChange}
                    onChange={newValue => setContact(newValue.value)}
                    options={contactList}
                    defaultValue={contactValues}
                  />
                  } */}

                </div>
              </div>
              <div className='row'>
                <div className='col-6 task-modal-input'>
                  <label for="task_title"  >
                    Reminder
                  </label>
                  <select
                    required
                    id="task_title"
                    className='kwDesign2 w-100'
                    onChange={(e) => {
                      if (e.target.value === 'Custom Date') {
                        setReminderCustomDate(true)
                      } else {
                        setReminderCustomDate(false)
                      }
                      setTaskReminder(e.target.value)
                    }}
                    ref={taskReminderRef}
                  >
                    <option value="No reminder">No reminder</option>
                    <option value="At task due time">At task due time</option>
                    <option value="30 minutes before">30 minutes before</option>
                    <option value="1 hour before">1 hour before </option>
                    <option value="1 day before">1 day before</option>
                    <option value="1 week before">1 week before</option>
                    <option value="Custom Date">Custom Date</option>
                  </select>
                </div>
                {
                  reminderCustomDate && <div className='col-6 task-modal-input'>
                    <label for="task_duedate"  >
                      Reminder Date
                    </label>
                    <input
                      required
                      id="task_duedate"
                      type="datetime-local"
                      className="kwDesign w-100"
                      onChange={(e) => {
                        let date = moment(new Date(e.target.value)).format('YYYY-MM-DD hh:mm a')
                        setTaskReminderCustomDate(date)
                      }}
                      ref={taskReminderCustomDateRef}
                    />
                  </div>
                }
              </div>
              <div className='row'>
                <div className='col-12 task-modal-input'>
                  <label for="task_title" >
                    Notes
                  </label>
                  <textarea
                    type="text"
                    id="task_title"
                    className='kwDesign w-100'
                    onChange={(e) => setTaskNote(e.target.value)}
                    ref={taskNoteRef}
                  />

                </div>
              </div>

              <div class="footerBtn d-flex justify-content-center align-items-center mt-4">
                <input
                  type="submit"
                  className="lg_btn primary m-2"
                  value={editTask ? "Save" : "Create"}
                  id="finalize"
                // data-dismiss="modal"
                 // onClick={(e) => { setEditTask(false); }}
                />
                <a to="" class="lg_btn tertiary m-2"
                  onClick={(e) => { reset(); $('#createTask').modal('hide'); }}
                >
                  Cancel
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div >
  )
}
